module.exports = __webpack_public_path__ + "static/404-bg-8c8e55c7a81895c152af6a1b77cb8c78.jpg";